import { makeStyles } from "@material-ui/core";
import { Colors } from "../../../../../utils";

const makeClasses = makeStyles((theme) => ({
  inputFile: {
    fontFamily: theme.fontFamily.regular,
    color: Colors.rgb.contentText,
    fontSize: theme.fontSize.L,
    borderBottom: `1px solid ${Colors.rgb.contentLine}`,
    paddingBottom: 4,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },

    "& > label": {
      position: "relative",
    },

    "& > label > div": {
      color: Colors.rgb.contentTextSoft,
      fontSize: theme.fontSize.S,
    },

    '& > input[type="file"]': {
      height: 0,
      position: "absolute",
    },
  },
  inputFileIcon: {
    position: "absolute",
    marginTop: 20,
    right: 0,
    top: 0,
  },

  contentActionsWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: theme.spacing(3),
    marginTop: theme.spacing(4),

    "& > button:last-child": {
      marginRight: 0,
    },
  },
}));

export default makeClasses;
